import { SearchEntity } from "./search_autocomplete.types";

export const SEARCH_AUTOCOMPLETE_FOOTER_ID = "search-autocomplete-footer";
export const SEARCH_AUTOCOMPLETE_FOOTER_BUTTON_ID = "search-autocomplete-footer-button";
export const DEFAULT_MIN_TERM_LENGTH = 0;
export const ACTIVITY_ENTITIES = [
  SearchEntity.Role,
  SearchEntity.AuditRole,
  SearchEntity.Engagement,
  SearchEntity.AuditEngagement
];
